// ===========================================
// ClientAvatar — Avatar avec initiales colorées par type
// Particulier = vert, Entreprise = bleu
// ===========================================
import React from 'react';

const getInitials = (client) => {
    if (!client) return '?';
    if (client.type === 'entreprise' || client.raisonSociale) {
        const rs = client.raisonSociale || client.nom || '';
        return rs.trim().slice(0, 2).toUpperCase() || '?';
    }
    const first = (client.prenom || '').trim()[0] || '';
    const last = (client.nom || '').trim()[0] || '';
    const combined = `${first}${last}`.toUpperCase();
    return combined || (client.nom || '?').slice(0, 2).toUpperCase();
};

const ClientAvatar = ({ client, size = 32 }) => {
    const isEntreprise = client?.type === 'entreprise' || !!client?.raisonSociale;
    const initials = getInitials(client);
    const className = `client-avatar client-avatar-${isEntreprise ? 'entreprise' : 'particulier'}`;

    return (
        <div
            className={className}
            style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
            aria-hidden="true"
        >
            {initials}
        </div>
    );
};

export default ClientAvatar;
